export const CROWD_APPLICATION_ID = 'crowd_monitoring';

export function crowdQuery(params: Record<string, string | undefined> = {}): string {
  const query = new URLSearchParams({ applicationId: CROWD_APPLICATION_ID });
  for (const [key, value] of Object.entries(params)) {
    if (value) query.set(key, value);
  }
  return query.toString();
}
